module.exports = __webpack_public_path__ + "img/banner-01.6aee2c47.jpg";